import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component,
  OnInit, ViewChild,
} from '@angular/core';
import * as _ from 'lodash';
import { Observable } from 'rxjs';

import { AccountInformationService } from '../../account-information.service';
import { InformationPageService } from '../../../information-page/information-page.service';
import { ProfileInfoService } from 'shared/profile/profile-info.service';
import { BrandService } from 'shared/brand/brand.service';
import LanguageCodeMapper from 'utils/language-code-mapper';
import { BaseAccountSegmentComponent } from '../base/_base-segment.component';
import { ProfileFormComponent } from './profile-form.component';

import { PROFILE_NAME } from '../../variables';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';

@Component({
  moduleId: module.id,
  selector: 'profile-segment',
  template: `
    <profile-form
      [data]='data'
      [segmentData]='segmentData'
      (save)='onSave($event)'
    ></profile-form>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ProfileComponent extends BaseAccountSegmentComponent implements OnInit {
  name: string = PROFILE_NAME;
  data: any = undefined;

  @ViewChild(ProfileFormComponent, {static: false})
  // @ts-ignore
  protected formComponent: ProfileFormComponent | void;

  constructor(
    protected accountInformationService: AccountInformationService,
    protected informationPageService: InformationPageService,
    protected ref: ChangeDetectorRef,
    private brandService: BrandService,
    private profileInfoService: ProfileInfoService,
  ) {
    super(
      accountInformationService,
      informationPageService,
      ref,
    );
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get isAllowedToSave(): boolean {
    // don't allow to save if form is invalid
    return this.form && this.form.valid;
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
    super.ngOnInit();
    this.refresh();
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  fetchFormData(): Observable<any> {
    return this.profileInfoService.fetch();
  }

  putFormData(): Observable<any> {
    if (!this.formComponent) {
      return;
    }
    const data = this.formComponent.form.value;
    return this.profileInfoService.put(data);
  }
}
